// frontend/src/pages/KRXIdxEarningsPage.js
import React, { useState, useEffect } from 'react';
import apiClient from '../../services/api';
import ReactECharts from 'echarts-for-react';
import useDateRange from '../../hooks/useDateRange';
import DateRangeControls from '../../components/DateRangeControls';
import { createChartOptions } from '../../utils/chartOptions';
import { Select, Typography, Card, Space, Divider } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import ResponsiveTypography from '../../components/ResponsiveTypography';

import Loading from '../../components/Loading';

const { Title } = ResponsiveTypography;
const { Text } = Typography;

const KRXIdxEarningsPage = () => {
    const [selectedAsset, setSelectedAsset] = useState('KOSPI200');
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { minDate, maxDate, viewStartDate, viewEndDate, handlePeriodChange, handleDateChange, isDateReady } = useDateRange(chartData, { dateColumn: 'Date', defaultPeriod: '10Y' });

    useEffect(() => {
        setLoading(true);
        apiClient.get(`/earnings/${selectedAsset}`).then(response => {
            setChartData(response.data);
            setLoading(false);
        });
    }, [selectedAsset]);

    const getChartOption = () => {
        if (!isDateReady) return {};
        const priceSeries = { name: `${selectedAsset} 지수`, type: 'line', yAxisIndex: 0, data: chartData.map(d => [d.Date, d.종가]) };
        const earningsSeries = { name: `${selectedAsset} 어닝`, type: 'line', yAxisIndex: 1, data: chartData.map(d => [d.Date, d.earnings]) };

        return createChartOptions({
            xAxis: { type: 'time' },
            yAxis: [
                { type: 'value', name: '주가지수', scale: true, log: true, axisLine: { show: true } },
                { type: 'value', name: '어닝 (EPS)', scale: true, log: true, axisLine: { show: true }, 
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: 'dotted',
                            color: 'gray'
                        }
                    }
                },
            ],
            dataZoom: [
                { type: 'slider', show: true, xAxisIndex: [0], bottom: '3%', startValue: viewStartDate.toISOString(), endValue: viewEndDate.toISOString() },
                { type: 'inside', xAxisIndex: [0] }
            ],
            series: [priceSeries, earningsSeries]
        });
    };

    if (loading || !isDateReady) {
        return <Loading />;
    }

    return (
        <div className="content-box">
            <Title style={{ marginLeft: "0.625rem", marginRight: "0.625rem", marginBottom: '2.0rem', marginTop: '1.5rem' }} level={2}>
                주가 지수 vs 어닝
            </Title>
            <Card style={{ marginTop: '1rem', padding: '0rem'}} bodyStyle={{ padding: '0.625rem'}}>
            
                <Space>
                    <Text 
                        strong
                        style={{ fontSize: 'inherit', transition: 'font-size 0.2s'}}
                    >
                        <SettingOutlined /> 주가지수 
                    </Text>
                    <Select value={selectedAsset} onChange={setSelectedAsset} 
                            style={{ width: 150 }} 
                            size='small'
                            options={[
                                        {value: 'KOSPI', label: 'KOSPI'}, 
                                        {value: 'KOSPI200', label: 'KOSPI200'}, 
                                        {value: 'KOSDAQ150', label: 'KOSDAQ150'}]} 
                    />
                </Space>

            </Card>
            <Card style={{ marginTop: '0.75rem' }} bodyStyle={{ padding: '0.625rem' }}>
                <Title 
                    level={4}
                >
                    {selectedAsset}  지수 vs TTM 어닝
                </Title>
                <Divider style={{ marginTop: '0.625rem', marginBottom: '0.625rem' }} />
                <ReactECharts option={getChartOption()} style={{ height: '25rem', marginTop: '0.625rem', padding: '0rem'}} showLoading={loading} />
                <Divider style={{ marginTop: '0.625rem', marginBottom: '1.25rem' }} />

                <DateRangeControls 
                    minDate={minDate} 
                    maxDate={maxDate} 
                    viewStartDate={viewStartDate} 
                    viewEndDate={viewEndDate} 
                    onPeriodChange={handlePeriodChange} 
                    onDateChange={handleDateChange} 
                />
            </Card>
        </div>
    );
};
export default KRXIdxEarningsPage;